import React, { Component } from 'react';
import Helmet from 'react-helmet';
import constants from '../config';
import './HelpPage.css';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDark: document.documentElement.classList.contains('tw-dark'),
      showScrollTop: false,
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      sending: false,
      sent: false,
      error: ''
    };
    this._observer = null;
    this._darkObserver = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this._handleScroll = this._handleScroll.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    var els = document.querySelectorAll('.help-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('help-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function(el) { observer.observe(el); });
      this._observer = observer;
    } else {
      els.forEach(function(el) { el.classList.add('help-visible'); });
    }

    window.addEventListener('scroll', this._handleScroll);
    var self = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== self.state.isDark) self.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._observer) this._observer.disconnect();
    if (this._darkObserver) this._darkObserver.disconnect();
    window.removeEventListener('scroll', this._handleScroll);
  }

  _handleScroll() {
    var show = window.scrollY > 400;
    if (show !== this.state.showScrollTop) this.setState({ showScrollTop: show });
  }

  handleSubmit(e) {
    e.preventDefault();
    var self = this;
    var { firstName, email, message } = this.state;

    if (!firstName.trim() || !email.trim() || !message.trim()) {
      this.setState({ error: 'Please fill in all required fields.' });
      return;
    }

    this.setState({ sending: true, error: '' });

    fetch(constants.DOMAIN + '/api/v1/guest/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: self.state.firstName.trim(),
        lastName: self.state.lastName.trim(),
        email: self.state.email.trim(),
        message: self.state.message.trim()
      })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.success) {
          self.setState({ sent: true, sending: false, firstName: '', lastName: '', email: '', message: '' });
        } else {
          self.setState({ error: data.error || 'Something went wrong. Please try again.', sending: false });
        }
      })
      .catch(function() {
        self.setState({ error: 'Failed to send message. Please try again.', sending: false });
      });
  }

  render() {
    var isDark = this.state.isDark;
    var state = this.state;
    var setState = this.setState.bind(this);

    var inputStyle = {
      width: '100%',
      padding: '10px 14px',
      fontSize: '14px',
      borderRadius: '8px',
      border: '1px solid ' + (isDark ? '#333' : '#d1d5db'),
      backgroundColor: isDark ? '#1a1a1a' : '#fff',
      color: isDark ? '#fff' : '#1a1a1a',
      outline: 'none',
      transition: 'border-color 0.15s ease',
      boxSizing: 'border-box'
    };

    var labelStyle = {
      display: 'block',
      fontSize: '13px',
      fontWeight: '600',
      color: isDark ? '#d1d5db' : '#374151',
      marginBottom: '6px'
    };

    return (
      <div style={{ backgroundColor: isDark ? '#111' : '#f9fafb', minHeight: '100vh' }}>
        <Helmet><title>Contact Us | Primal Market</title></Helmet>

        {/* Hero */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
          padding: '60px 20px 48px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              width: '56px', height: '56px', borderRadius: '16px',
              backgroundColor: 'rgba(201,168,76,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <i className="fa fa-envelope" style={{ color: '#c9a84c', fontSize: '24px' }} />
            </div>
            <h1 style={{ color: '#fff', fontSize: '32px', fontWeight: '700', marginBottom: '12px', marginTop: 0 }}>
              Contact Us
            </h1>
            <p style={{ color: '#9ca3af', fontSize: '16px', maxWidth: '500px', margin: '0 auto', lineHeight: '1.6' }}>
              Have a question or need help? We're here for you.
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '32px 16px 64px' }}>

          {/* Two-column: Info left, Form right */}
          <div className="help-reveal help-fade-up help-delay-2 help-section-card" style={{
            backgroundColor: isDark ? '#141414' : '#fff',
            border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'),
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '0'
            }}>
              {/* Left: Contact Info */}
              <div style={{
                padding: '36px 32px',
                borderRight: isDark ? '1px solid #2a2a2a' : '1px solid #e8e8e8'
              }}>
                {/* Office */}
                <div style={{ marginBottom: '36px' }}>
                  <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                    <div style={{
                      width: '40px', height: '40px', borderRadius: '10px',
                      backgroundColor: 'rgba(201,168,76,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <i className="fa fa-map-marker" style={{ color: '#c9a84c', fontSize: '18px' }} />
                    </div>
                    <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
                      Find us at the office
                    </h3>
                  </div>
                  <div style={{ color: isDark ? '#9ca3af' : '#6b7280', fontSize: '14px', lineHeight: '1.7', paddingLeft: '52px' }}>
                    <strong style={{ color: isDark ? '#d1d5db' : '#374151' }}>Dattebayo Labs LLC</strong><br />
                    4296 SW 9th Ter,<br />
                    Miami, FL 33134
                  </div>
                </div>

                {/* Phone */}
                <div style={{ marginBottom: '36px' }}>
                  <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                    <div style={{
                      width: '40px', height: '40px', borderRadius: '10px',
                      backgroundColor: 'rgba(201,168,76,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <i className="fa fa-phone" style={{ color: '#c9a84c', fontSize: '16px' }} />
                    </div>
                    <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
                      Give us a ring
                    </h3>
                  </div>
                  <div style={{ color: isDark ? '#9ca3af' : '#6b7280', fontSize: '14px', lineHeight: '1.7', paddingLeft: '52px' }}>
                    <strong style={{ color: isDark ? '#d1d5db' : '#374151' }}>Dattebayo Labs LLC</strong><br />
                    +1 786 663 0320<br />
                    Mon - Fri, 6:00 PM-10:00 PM EST
                  </div>
                </div>

                {/* Discord */}
                <div>
                  <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                    <div style={{
                      width: '40px', height: '40px', borderRadius: '10px',
                      backgroundColor: 'rgba(88,101,242,0.12)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <svg width="16" height="16" viewBox="0 0 71 55" fill="#5865F2" xmlns="http://www.w3.org/2000/svg"><path d="M60.1 4.9A58.5 58.5 0 0045.4.2a.2.2 0 00-.2.1 40.8 40.8 0 00-1.8 3.7 54 54 0 00-16.2 0A37.4 37.4 0 0025.4.3a.2.2 0 00-.2-.1A58.4 58.4 0 0010.5 4.9a.2.2 0 00-.1.1C1.5 18.7-.9 32.2.3 45.5v.2a58.9 58.9 0 0017.7 9a.2.2 0 00.3-.1 42.1 42.1 0 003.6-5.9.2.2 0 00-.1-.3 38.8 38.8 0 01-5.5-2.7.2.2 0 01 0-.4l1.1-.9a.2.2 0 01.2 0 42 42 0 0035.6 0 .2.2 0 01.2 0l1.1.9a.2.2 0 010 .4 36.4 36.4 0 01-5.5 2.7.2.2 0 00-.1.3 47.3 47.3 0 003.6 5.9.2.2 0 00.3.1A58.7 58.7 0 0070.5 45.7v-.2c1.4-15-2.3-28.1-9.8-39.7a.2.2 0 00-.1 0zM23.7 37.3c-3.4 0-6.3-3.2-6.3-7s2.8-7 6.3-7 6.4 3.1 6.3 7-2.8 7-6.3 7zm23.2 0c-3.4 0-6.3-3.2-6.3-7s2.8-7 6.3-7 6.4 3.1 6.3 7-2.8 7-6.3 7z"/></svg>
                    </div>
                    <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
                      Discord Community
                    </h3>
                  </div>
                  <div style={{ paddingLeft: '52px' }}>
                    <p style={{ color: isDark ? '#9ca3af' : '#6b7280', fontSize: '14px', lineHeight: '1.6', margin: '0 0 12px' }}>
                      The fastest way to get help. Join our Discord and reach out to the team directly.
                    </p>
                    <a
                      href="https://discord.com/invite/pxTRcC32nZ"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="tw-no-underline"
                      style={{
                        display: 'inline-block', backgroundColor: '#5865F2', color: '#fff',
                        fontWeight: '600', fontSize: '13px', padding: '8px 18px',
                        borderRadius: '8px', textDecoration: 'none', transition: 'background-color 0.15s ease'
                      }}
                      onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = '#4752C4'; }}
                      onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = '#5865F2'; }}
                    >
                      <i className="fa fa-external-link" style={{ marginRight: '6px', fontSize: '11px' }} />
                      Join Our Discord
                    </a>
                  </div>
                </div>
              </div>

              {/* Right: Contact Form */}
              <div style={{ padding: '36px 32px' }}>
                {state.sent ? (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <div style={{
                      width: '56px', height: '56px', borderRadius: '50%',
                      backgroundColor: 'rgba(34,197,94,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 16px'
                    }}>
                      <i className="fa fa-check" style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                    <h3 style={{ margin: '0 0 8px', fontSize: '20px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
                      Message Sent!
                    </h3>
                    <p style={{ color: isDark ? '#9ca3af' : '#6b7280', fontSize: '14px', margin: '0 0 20px' }}>
                      We'll get back to you within 1–2 business days.
                    </p>
                    <button
                      onClick={function() { setState({ sent: false }); }}
                      style={{
                        backgroundColor: 'transparent', border: '1px solid ' + (isDark ? '#333' : '#d1d5db'),
                        color: isDark ? '#d1d5db' : '#374151', padding: '8px 20px',
                        borderRadius: '8px', fontSize: '14px', cursor: 'pointer'
                      }}
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={this.handleSubmit}>
                    {/* Name row */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                      <div>
                        <label style={labelStyle}>First name <span style={{ color: '#ef4444' }}>*</span></label>
                        <input
                          type="text"
                          placeholder="First Name"
                          value={state.firstName}
                          onChange={function(e) { setState({ firstName: e.target.value, error: '' }); }}
                          style={inputStyle}
                          onFocus={function(e) { e.target.style.borderColor = '#c9a84c'; }}
                          onBlur={function(e) { e.target.style.borderColor = isDark ? '#333' : '#d1d5db'; }}
                        />
                      </div>
                      <div>
                        <label style={labelStyle}>Last name</label>
                        <input
                          type="text"
                          placeholder="Last Name"
                          value={state.lastName}
                          onChange={function(e) { setState({ lastName: e.target.value }); }}
                          style={inputStyle}
                          onFocus={function(e) { e.target.style.borderColor = '#c9a84c'; }}
                          onBlur={function(e) { e.target.style.borderColor = isDark ? '#333' : '#d1d5db'; }}
                        />
                      </div>
                    </div>

                    {/* Email */}
                    <div style={{ marginBottom: '16px' }}>
                      <label style={labelStyle}>Email address <span style={{ color: '#ef4444' }}>*</span></label>
                      <input
                        type="email"
                        placeholder="Email"
                        value={state.email}
                        onChange={function(e) { setState({ email: e.target.value, error: '' }); }}
                        style={inputStyle}
                        onFocus={function(e) { e.target.style.borderColor = '#c9a84c'; }}
                        onBlur={function(e) { e.target.style.borderColor = isDark ? '#333' : '#d1d5db'; }}
                      />
                    </div>

                    {/* Message */}
                    <div style={{ marginBottom: '20px' }}>
                      <label style={labelStyle}>Your message <span style={{ color: '#ef4444' }}>*</span></label>
                      <textarea
                        placeholder="Message"
                        value={state.message}
                        onChange={function(e) { setState({ message: e.target.value, error: '' }); }}
                        rows={5}
                        style={Object.assign({}, inputStyle, { resize: 'vertical', minHeight: '120px' })}
                        onFocus={function(e) { e.target.style.borderColor = '#c9a84c'; }}
                        onBlur={function(e) { e.target.style.borderColor = isDark ? '#333' : '#d1d5db'; }}
                      />
                    </div>

                    {/* Error */}
                    {state.error && (
                      <div style={{
                        backgroundColor: isDark ? 'rgba(239,68,68,0.1)' : '#fef2f2',
                        color: '#ef4444', fontSize: '13px', padding: '10px 14px',
                        borderRadius: '8px', marginBottom: '16px',
                        border: '1px solid ' + (isDark ? 'rgba(239,68,68,0.2)' : '#fecaca')
                      }}>
                        {state.error}
                      </div>
                    )}

                    {/* Submit */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <button
                        type="submit"
                        disabled={state.sending}
                        className="help-cta-btn"
                        style={{
                          backgroundColor: '#c9a84c',
                          color: '#000',
                          fontWeight: '600',
                          fontSize: '14px',
                          padding: '10px 28px',
                          borderRadius: '8px',
                          border: 'none',
                          cursor: state.sending ? 'not-allowed' : 'pointer',
                          opacity: state.sending ? 0.7 : 1
                        }}
                      >
                        {state.sending ? 'Sending...' : 'SEND MESSAGE'}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>

          {/* Response Time */}
          <div className="help-reveal help-fade-up help-delay-3" style={{
            backgroundColor: isDark ? '#1a1a1a' : '#f0f4ff',
            borderRadius: '12px',
            padding: '20px 24px',
            textAlign: 'center',
            border: '1px solid ' + (isDark ? '#2a2a2a' : '#dce3f5')
          }}>
            <i className="fa fa-clock-o" style={{ color: '#c9a84c', fontSize: '18px', marginBottom: '8px', display: 'block' }} />
            <p style={{ margin: 0, fontSize: '14px', color: isDark ? '#d1d5db' : '#4b5563' }}>
              <strong>Response Time:</strong> We typically respond within 24 hours on Discord and 1–2 business days via email.
            </p>
          </div>

        </div>

        {this.state.showScrollTop && (
          <button
            onClick={function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="tw-fixed tw-bottom-6 tw-right-6 tw-w-10 tw-h-10 tw-rounded-full tw-bg-brand-gold tw-text-black tw-border-0 tw-cursor-pointer tw-z-40 tw-flex tw-items-center tw-justify-center"
            style={{ boxShadow: '0 4px 16px rgba(201, 168, 76, 0.3)' }}
            aria-label="Scroll to top"
          >
            <svg className="tw-w-6 tw-h-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    );
  }
}

export default ContactUs;
